import { render } from "./ExerciseForm.vue?vue&type=template&id=5da62dba"
import script from "./ExerciseForm.vue?vue&type=script&lang=js"
export * from "./ExerciseForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__